import { render, staticRenderFns } from "./BranchManager.vue?vue&type=template&id=6d2839b2&"
import script from "./BranchManager.vue?vue&type=script&lang=js&"
export * from "./BranchManager.vue?vue&type=script&lang=js&"
import style0 from "./BranchManager.vue?vue&type=style&index=0&id=6d2839b2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports